// Vencimientos de documentos opcionales del conductor (informativos: no suspenden ni bloquean asignación)
import React from "react";
import { Form, DatePicker, Row, Col, Typography } from "antd";
import PropTypes from "prop-types";
import dayjs from "../../../../utils/dayjs";

const { Title } = Typography;

export const VENCIMIENTOS_CONDUCTOR = [
  { campo: "fecha_venc_seguridad_social", nombre: "Seguridad Social" },
  { campo: "fecha_venc_examen_medico", nombre: "Examen Médico" },
  { campo: "fecha_venc_curso_mecanica_basica", nombre: "Curso Mecánica Básica" },
  { campo: "fecha_venc_curso_manejo_defensivo", nombre: "Curso Manejo Defensivo" },
  { campo: "fecha_venc_curso_primeros_auxilios", nombre: "Curso Primeros Auxilios" },
  { campo: "fecha_venc_curso_seguridad_vial", nombre: "Curso Seguridad Vial" },
  { campo: "fecha_venc_curso_extintores", nombre: "Curso Manejo de Extintores" },
  { campo: "fecha_venc_curso_mision_medica", nombre: "Curso Misión Médica" },
];

const VencimientosDocumentosInfo = ({ driver, handleInputChange, errors }) => (
  <>
    <Title
      level={4}
      style={{
        backgroundColor: "#0a2e5c",
        color: "white",
        padding: "8px 16px",
        borderRadius: "4px",
        marginTop: 24,
        marginBottom: 16,
      }}
    >
      Vencimientos de Documentos
    </Title>
    <Row gutter={16}>
      {VENCIMIENTOS_CONDUCTOR.map(({ campo, nombre }) => (
        <Col xs={24} sm={12} md={8} key={campo}>
          <Form.Item
            label={nombre}
            validateStatus={errors[campo] ? "error" : ""}
            help={errors[campo]}
          >
            <DatePicker
              name={campo}
              value={driver[campo] ? dayjs(driver[campo]) : null}
              onChange={(date, dateString) =>
                handleInputChange({
                  target: { name: campo, value: dateString || null },
                })
              }
              format="YYYY-MM-DD"
              style={{ width: "100%" }}
              placeholder="Opcional"
            />
          </Form.Item>
        </Col>
      ))}
    </Row>
  </>
);

VencimientosDocumentosInfo.propTypes = {
  driver: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
};

export default VencimientosDocumentosInfo;
